import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import { ReactReduxContext, isLegacyReactRedux } from "./legacy/contextAdapter";
import { LegacifyContext, ModernizeContext } from "./legacy/LegacyAdapters";
import { injectCurrents } from "./storage";
import { monkeyPatchStore } from "./monkeyPatch";
var ModernCurrentBulkProvider = function ModernCurrentBulkProvider(_ref) {
  var children = _ref.children,
    values = _ref.values;
  var context = useContext(ReactReduxContext);

  /**
   * Injector should be memoized for provider lifetime
   *
   * TODO: Move to separate hook with extra comments
   */
  var contextInjector = React.useMemo(function () {
    return memoizeOne(injectCurrents);
  }, []);
  var patchedStore = React.useMemo(function () {
    return monkeyPatchStore(contextInjector, context.store, values);
  }, [contextInjector, context.store, values]);
  var nextContext = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      store: patchedStore
    });
  }, [context, patchedStore]);
  return /*#__PURE__*/React.createElement(ReactReduxContext.Provider, {
    value: nextContext
  }, children);
};
ModernCurrentBulkProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
  // any key/value
} : {};

/**
 * To reduce noise:
 * 1. convert legacy context to modern
 * 2. use modern context
 * 3. convert it back to legacy
 */
var LegacyCurrentBulkProvider = function LegacyCurrentBulkProvider(_ref2) {
  var children = _ref2.children,
    values = _ref2.values;
  return /*#__PURE__*/React.createElement(ModernizeContext, null, /*#__PURE__*/React.createElement(ModernCurrentBulkProvider, {
    values: values
  }, /*#__PURE__*/React.createElement(LegacifyContext, null, children)));
};
LegacyCurrentBulkProvider.propTypes = process.env.NODE_ENV !== "production" ? ModernCurrentBulkProvider.propTypes : {};
export var CurrentBulkProvider = isLegacyReactRedux ? LegacyCurrentBulkProvider : ModernCurrentBulkProvider;
export var CurrentKeyProvider = function CurrentKeyProvider(_ref3) {
  var children = _ref3.children,
    name = _ref3.name,
    value = _ref3.value;
  var values = React.useMemo(function () {
    return _defineProperty({}, name, value);
  }, [name, value]);
  return /*#__PURE__*/React.createElement(CurrentBulkProvider, {
    values: values
  }, children);
};
CurrentKeyProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.symbol]).isRequired,
  // Truly any value
  // eslint-disable-next-line
  value: PropTypes.any
} : {};

/**
 * @deprecated I hereby declare this naming deprecated, use CurrentKeyProvider instead
 */
export var ProvideCurrentKey = CurrentKeyProvider;